import { render, staticRenderFns } from "./LabelManage.vue?vue&type=template&id=e7034604&scoped=true"
import script from "./LabelManage.vue?vue&type=script&lang=js"
export * from "./LabelManage.vue?vue&type=script&lang=js"
import style0 from "./LabelManage.vue?vue&type=style&index=0&id=e7034604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7034604",
  null
  
)

export default component.exports